// Helper function with better error handling
// Flattens the employees hierarchy tree into a flat list for table display.
// `expandedEmployees` is a Set of infinityCodes whose children should be visible.
export const flattenHierarchy = (
  node,
  expandedEmployees,
  level = 0,
  result = [],
  visited = new Set(),
  parentExpanded = true
) => {
  if (!node) return result;

  if (visited.has(node.infinityCode)) {
    console.warn(`⚠️ Circular reference detected: ${node.infinityCode}`);
    return result;
  }

  visited.add(node.infinityCode);

  // ✅ أضف الـ node بس لو الـ parent مفتوح (أو هو root)
  if (parentExpanded) {
    result.push({
      ...node,
      level,
      isExpanded: expandedEmployees.has(node.infinityCode),
      hasChildren: node.children && node.children.length > 0,
    });
  }

  // ✅ أظهر children بس لو الـ node ده مفتوح
  const shouldShowChildren = expandedEmployees.has(node.infinityCode);

  if (shouldShowChildren && node.children && node.children.length > 0) {
    node.children.forEach(child => {
      flattenHierarchy(child, expandedEmployees, level + 1, result, new Set(visited), true);
    });
  }

  return result;
};
